import { Component } from '@angular/core';
import { injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';

export interface PrivateAppDialogContext {
  /** the page asked for, at the address where the console runs */
  to: string;
  close: () => void;
}

/**
 * Tells the reader that the page they asked for is not served by this build, and where it is,
 * before taking them there (privateAppGuard).
 */
@Component({
  selector: 'app-private-app-dialog',
  template: `
    <div class="p-6 max-w-md">
      <div class="flex items-center gap-2 mb-3">
        <ng-icon hlm size="base" name="lucideInfo" class="text-primary"></ng-icon>
        <h3 class="text-lg font-semibold">You are leaving ulabase.com</h3>
      </div>
      <p class="text-sm text-muted-foreground mb-3">
        Ulabase is the new name of RESTHeart Cloud. For a few more days the console and the plans are still at the old
        address, <strong class="text-foreground">{{ host }}</strong>, under the old name.
      </p>
      <p class="text-sm text-muted-foreground mb-5">
        Your account, your services and your data are there, as they are. Nothing to migrate.
      </p>
      <div class="flex justify-end gap-2 flex-wrap">
        <button type="button" hlmBtn variant="outline" (click)="context.close()">Stay here</button>
        <a hlmBtn [href]="context.to">Continue to {{ host }}</a>
      </div>
    </div>
  `,
  imports: [...HlmIconImports, ...HlmButtonImports],
})
export class PrivateAppDialogComponent {
  protected context = injectBrnDialogContext<PrivateAppDialogContext>();
  protected host = new URL(this.context.to).host;
}
